<template>
  <button
    type="button"
    class="tw-flex tw-items-center tw-justify-center tw-mx-2 tw-rounded-full tw-border-none tw-bg-secondary-100/0 tw-outline-none tw-ring-4 tw-ring-secondary-100/0"
    :class="classes"
    :data-test-id="testId"
    :disabled="disabled || readonly"
    @click="emitClick"
  >
    <slot />
  </button>
</template>

<script lang="ts" setup>
import { computed } from "vue";

export interface Props {
  testId: string;
  disabled?: boolean;
  readonly?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  readonly: false,
});

const emit = defineEmits<{
  (event: "on-click"): void;
}>();

const emitClick = (): void => {
  emit("on-click");
};

const classes = computed(() => {
  if (props.disabled) {
    return "tw-text-dorian-gray-200 tw-cursor-default";
  }
  if (props.readonly) {
    return "tw-text-dorian-gray-500 tw-cursor-not-allowed";
  }
  return "tw-text-dorian-gray-500 tw-transition-all hover:tw-bg-secondary-100 hover:tw-text-secondary-500 hover:tw-ring-secondary-100 active:tw-bg-secondary-200 active:tw-ring-secondary-200 dark:hover:tw-bg-secondary-200 dark:hover:tw-ring-secondary-200 dark:active:tw-bg-secondary-100 dark:active:tw-ring-secondary-100";
});
</script>
